import lozad from "lozad";
import {MobileMenu} from "./components/mobile-menu";
import {initMainPageLanding} from "./pages/main-page";
import {initCatalogPageLanding} from "./pages/catalog-page";
import {initProductPageLanding} from "./pages/product-page";
import {initPlaceholders} from "./components/form/inputs";
import {initCustomShirtComponent} from "./components/custom-shirt/custom-shirt";
import {initCartPage} from "./pages/cart-page";
import tippy from "tippy.js";
import {initPaymentStatusPage} from "./pages/payment_page";
import {getRightPrice, initSelects, numberFormat} from "./components/helpers";

$( document ).ready(function() {
    const mobileMenu = new MobileMenu();

    const observer = lozad();
    observer.observe();


    $('body').on('click', '.mobile-menu-toggle-button', function () {
        mobileMenu.toggle();
        return false;
    });

    initPlaceholders();
    initHandlers();
    initTooltips();

    if($('#custom_shirt_block').length !== 0){
        initCustomShirtComponent();
    }

    initMainPageLanding();
    initCatalogPageLanding();
    initProductPageLanding();
    initCartPage();
    initPaymentStatusPage();

    function initHandlers(){
        //выбор размера
        $('body').on('click', '.switcher:not(.disabled):not(.category):not(.custom-shirt-size)', e => {
            e.preventDefault();

            const $clickedSize = $(e.currentTarget);
            const $noSizeText = $clickedSize.parent().parent().find('[data-no-sizes-chosen]');
            const $priceBlock = $(e.currentTarget).parents('.product-card').find('[data-product-price-text]');
            const clickedSizePrice = $(e.currentTarget).data('price');

            if(!$clickedSize.hasClass('chosen')){
                if($clickedSize.data('saleprice') && +$clickedSize.data('saleprice') !== 0){
                    const $withoutSalePrice = $clickedSize.parents('.product-card').find('[data-product-without-sale-price-text]');
                    const salePrice = $clickedSize.data('saleprice');

                    $('[data-product-without-sale-price-text]').removeClass('hide');
                    $withoutSalePrice.text(`${getRightPrice(clickedSizePrice)} ₽`);
                    $priceBlock.text(`${getRightPrice(salePrice)} ₽`);

                }else{
                    $('[data-product-without-sale-price-text]').addClass('hide');
                    $priceBlock.text(`${getRightPrice(clickedSizePrice)} ₽`);
                }

                $clickedSize.addClass('chosen').siblings('.switcher:not(.disabled)').removeClass('chosen');

                $noSizeText.css('opacity', 0);
            }

            //изменение цены на странице продукта
            if($clickedSize.hasClass('size-2') && !$('#custom_shirt_block').length){
                if($clickedSize.data('saleprice') && +$clickedSize.data('saleprice') !== 0){
                    const salePrice = $clickedSize.data('saleprice');
                    $('[data-product-without-sale-price-text]').removeClass('hide');
                    $('[data-product-without-sale-price-text]').text(`${numberFormat(clickedSizePrice, 0, '', ' ')} ₽`);
                    $('[data-product-price]').data('product-price', salePrice);
                    $('[data-product-price]').text(`${numberFormat(salePrice, 0, '', ' ')} ₽`);

                }else{
                    $('[data-product-without-sale-price-text]').addClass('hide');
                    $('[data-product-price]').data('product-price', clickedSizePrice);
                    $('[data-product-price]').text(`${numberFormat(clickedSizePrice, 0, '', ' ')} ₽`);
                }
            }

            //изменение выбора количества на странице продукта при переключении размеров
            if($clickedSize.hasClass('size-2')){

                const maxCountFromSize = +$clickedSize.data('count');
                const $select = $('#product_count');
                let result = '';
                Array.from({length: maxCountFromSize}, (v, k) => k + 1).forEach(value => {
                    if (value === 1) {
                        result += `<option selected value="${value}">${value}</option>`;

                    } else {
                        result += `<option value="${value}">${value}</option>`;
                    }
                });
                result = '<select class="select">' + result + '</select>';

                $select.html(result);
                initSelects();
            }

            if(!$clickedSize.hasClass('custom-shirt-size')){
                $('.inputs-wrapper').find('[data-no-sizes-chosen]').css('opacity', 0)
            }
        });
    }

    function initTooltips() {
        $.each($('[data-tooltip]'), function () {
            tippy($(this)[0], {
                arrow: false,
                content: $(this).attr('data-tooltip'),
                theme: 'azureGradient'
            })
        })
    }
})